import * as THREE from 'three'
import { Text, Html } from '@react-three/drei'
import React, { createRef, useCallback, useRef, useState } from 'react'
import { useFrame } from '@react-three/fiber'
import { Typography } from '@mui/material'
import { Euler, Vector3 } from 'three'
import { RulerInformation } from './rulers'

const textProps = {
  fontSize: 0.1,
  //font: 'Arial',
  color: 'black',
}

const Text2 = ({ layers = undefined, ...props }): JSX.Element => {
  const group: any = useRef()
  return (
    <group {...props} ref={group}>
      <Html
        style={{
          position: 'relative',
          left: '-50%',
          top: '-5px',
          minWidth: '100px',
        }}
        distanceFactor={5}
      >
        <Typography
          variant={'h6'}
          gutterBottom
          color="text.primary"
          // {...props}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            fontSize: '1.3rem',
            padding: '0 5px',
            textShadow: '1px 1px 1px rgba(250,250,250, 0.4)',
          }}
        >
          {props.text}
        </Typography>
      </Html>
    </group>
  )
}

export const Ruler = (props: {
  rule: RulerInformation
}): JSX.Element => {
  return (
    <mesh position={[0, 0, 0]}>
      <Line {...props.rule} />
    </mesh>
  )
}

const StartEndLine = (props: { start: any; direction: string }) => {
  let ref: any = createRef<THREE.Line | null>()

  useFrame(() => {
    const start = props.start.map((s: number, i: number) => {
      if (props.direction == 'x') {
        return i == 2 ? props.start[2] - 0.08 : s
      } else if (props.direction == 'y') {
        return i == 0 ? props.start[0] + 0.08 : s
      } else if (props.direction == 'z') {
        return i == 0 ? props.start[0] - 0.08 : s
      }
    })
    if (ref.current) {
      ref.current.geometry.setFromPoints(
        [start, props.start].map((point) => new THREE.Vector3(...point))
      )
    }
  })

  return (
    <line ref={ref}>
      <bufferGeometry />
      <lineBasicMaterial color="black" linewidth={0.1} />
    </line>
  )
}

const Line = (props: RulerInformation) => {
  let ref: any = createRef<THREE.Line | null>()
  let ref1: any = createRef<THREE.Line | null>()
  const end = props.startPoint.map((s: number, i: number) => {
    if (props.direction == 'x') {
      return i == 0 ? props.startPoint[0] + props.endPoint[0] - 0.1 : s
    } else if (props.direction == 'y') {
      return i == 1 ? (props.startPoint[1] + props.endPoint[1]) / 2 - 0.1 : s
    } else if (props.direction == 'z') {
      return i == 2 ? (props.startPoint[2] + props.endPoint[2]) / 2 - 0.1 : s
    }
  })
  const start = props.endPoint.map((s: number, i: number) => {
    if (props.direction == 'x') {
      return i == 0 ? props.endPoint[0] + props.startPoint[0] + 0.1 : s
    } else if (props.direction == 'y') {
      return i == 1 ? (props.startPoint[1] + props.endPoint[1]) / 2 + 0.1 : s
    } else if (props.direction == 'z') {
      return i == 2 ? (props.startPoint[2] + props.endPoint[2]) / 2 + 0.1 : s
    }
  })
  useFrame(() => {
    if (ref.current) {
      ref.current.geometry.setFromPoints(
        [start, props.endPoint].map((point) => new THREE.Vector3(...point))
      )
    }
    if (ref1.current) {
      ref1.current.geometry.setFromPoints(
        [props.startPoint, end].map((point) => new THREE.Vector3(...point))
      )
    }
  })

  return (
    <group>
      <StartEndLine start={props.startPoint} direction={props.direction} />
      <line ref={ref}>
        <bufferGeometry />
        <lineBasicMaterial color="black" linewidth={1.1} />
      </line>

      <Text
        position={props.textPosition as any}
        color="black"
        rotation={props.textRotation as any}
      >
        {props.length}
      </Text>

      <line ref={ref1}>
        <bufferGeometry />
        <lineBasicMaterial color="black" linewidth={1.1} />
      </line>
      <StartEndLine start={props.endPoint} direction={props.direction} />
    </group>
  )
}

const textPosition = (start: any, length: number, direction: string) => {
  const startText = start.map((s: number, i: number) => {
    if (i == 1) {
      s += 0.05
    }
    if (direction == 'x') {
      return i == 0 ? 0 : s
    } else if (direction == 'y') {
      return i == 1 ? length / 2 + 0.03 : s
    } else if (direction == 'z') {
      return i == 2 ? length / 2 + 0.0 : s
    }
  })
  return startText
}
